export default __webpack_public_path__ + "static/media/zero-risk.f7e2aa07.webp";